import React, { useState, useEffect } from 'react';
import ProductList from './ProductList';
import { useParams } from "react-router-dom";


function ProductByJenis() {
    const params = useParams();
    const [productAllAcne, SetProductAllAcne] = useState([]);


    useEffect(() => {
        fetch(`https://dev.jftheskinspecialist.com/api/productjenis/${params.id}`)
            .then((res) => {
                return res.json();
            })
            .then((datas) => {
                console.log(datas.data);
                SetProductAllAcne(datas.data);
            });
    }, []);

    return (
        <div className="p-4 bg-[#fefaed]">
            <section class="py-10 text-center">
                <div class="mb-6" style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
                    <h3 class="text-[#ff8e35] font-bold text-[18px] inline-block border-b-4 pb-2">
                        <span class="uppercase">{params.id}</span>
                    </h3>
                </div>

                <section class="py-0 text-center">
                    <div class="max-w-full px-4 py-10 sm:px-6 lg:px-0 lg:py-0 mx-auto">
                        <ProductList products={productAllAcne} />
                    </div>
                </section>

            </section>
        </div>
    );
}

export default ProductByJenis;
